import React from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import './Introduction.css';

export function WorkIntroduction() {
  return (
    <header className="introduction">
      <h1 className="intro-heading">hi, i'm aidan</h1>
      <p className="location">
        <FaMapMarkerAlt className="location-icon" /> london, uk
      </p>
      <p className="intro-text">
        currently working at{' '}
        <a
          href="https://www.bny.com/corporate/global/en/solutions/platforms/data-and-analytics.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          bny
        </a>
        , within growth ventures building data management and analysis solutions for buy-side clients.
      </p>
    </header>
  );
}
